import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/dispatchers';

class dispatchersService {
    /**
     * Tworzy nowego dyspozytora, wysyłając dane dyspozytora do endpointu.
     * 
     * @param {Object} dispatcher - Obiekt zawierający dane nowego dyspozytora.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnym utworzeniu dyspozytora.
     */
    createDispatcher(dispatcher) {
        return axios.post(API_URL, dispatcher);
    }

    /**
     * Pobiera listę wszystkich dyspozytorów.
     * 
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera zawierającą listę wszystkich dyspozytorów.
     */
    getAllDispatchers() {
        return axios.get(API_URL);
    }

    /**
     * Pobiera dane dyspozytora na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID dyspozytora, którego chcemy pobrać.
     * @returns {Promise<Object>} Zwraca dane dyspozytora o podanym ID.
     */
    getDispatcherById(id) {
        return axios.get(`${API_URL}/${id}`);
    }

    /**
     * Aktualizuje dane dyspozytora na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID dyspozytora, którego chcemy zaktualizować.
     * @param {Object} updatedDispatcher - Obiekt zawierający zaktualizowane dane dyspozytora.
     * @returns {Promise<Object>} Zwraca odpowiedź z serwera po pomyślnej aktualizacji danych dyspozytora.
     */
    updateDispatcher(id, updatedDispatcher) {
        return axios.put(`${API_URL}/${id}`, updatedDispatcher);
    }

    /**
     * Usuwa dyspozytora na podstawie jego identyfikatora (ID).
     * 
     * @param {number|string} id - ID dyspozytora, którego chcemy usunąć.
     * @returns {Promise<void>} Zwraca odpowiedź z serwera po pomyślnym usunięciu dyspozytora.
     */
    deleteDispatcher(id) {
        return axios.delete(`${API_URL}/${id}`);
    }
}

export default new dispatchersService();
